import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { Table } from "antd";
import { v4 as uuidv4 } from "uuid";
import "../Components/Pcr/PcrUploadXMLAlert.css";
import "../Components/QC/QC.css";
import "./BlockedResultsModal.css";

const BlockedResultsTableRow = ({
  record,
  ...antdProps
}) => {
  if (!record) {
    return <tr {...antdProps} />; // eslint-disable-line react/jsx-props-no-spreading
  }

  return (
    <tr
      {...antdProps} // eslint-disable-line
      className="QCTableRow"
    />
  );
};

const BlockedResultsTableCell = ({
  record,
  dataIndex,
  ...antdProps
}) => {
  if (!record) {
    return <td {...antdProps} />; // eslint-disable-line react/jsx-props-no-spreading
  }
  const childNode = record[dataIndex];
  return (<td {...antdProps}>{childNode}</td>); // eslint-disable-line
};

export default function BlockedResultsModal({
  title, columns, blockedResults, toggleModal,
}) {
  const hasResults = blockedResults.length > 0;

  const tableData = hasResults
    ? blockedResults.map((item) => ({
      ...item,
      key: uuidv4(),
    }))
    : [];

  return (
    <div>
      <SweetAlert
        confirmBtnBsStyle="btn-hide"
        onConfirm={() => {}}
        customClass="BlockedResultsModal__SweetAlert"
        title=""
        onCancel={toggleModal}
        closeOnClickOutside={false}
        allowEscape={false}
      >
        <div className="pcrXMLModalHeaderContainer">
          <div>
            <div>
              {title}
            </div>
          </div>
          <div>
            <div className="pcrXMLModalHeaderClose">
              <p className="pcrXMLCloseButton" onClick={toggleModal}>
                ✖
              </p>
            </div>
          </div>
        </div>

        {hasResults ? (
          <div className="BlockedResultsModal__TableContainer">
            <Table
              sticky
              className="QCTable"
              dataSource={tableData}
              scroll={{ y: "60vh" }}
              pagination={false}
              bordered
              components={{
                body: {
                  row: BlockedResultsTableRow,
                  cell: BlockedResultsTableCell,
                },
              }}
              onRow={(record) => ({
                record,
              })}
              columns={columns.map((col) => ({
                ...col,
                onCell: (record) => ({
                  record,
                  dataIndex: col.dataIndex,
                }),
              }))}
            />
          </div>
        ) : (
          <div className="pcrXMLAllGpc">
            <p>No blocked results found.</p>
          </div>
        )}
      </SweetAlert>
    </div>
  );
}
